module.exports = __webpack_public_path__ + "img/huawei-2.10f4375a.png";